import { TFunction } from "i18next";
import BusinessRole from "fe-shared/src/types/domain/BusinessRole";

import {
  getCommonColumnDefs,
  getCommonRenderers,
} from "fe-shared-transactions/src/helpers/transactionsGridConfig";

import { TypeRenderer } from "fe-shared-transactions/src/components/TransactionsDataGrid/renderers";
import CarrierRenderer from "../renderers/CarrierRenderer";

export const getColumnDefs = (
  t: TFunction,
  businessRoleCode: BusinessRole,
  canCreateInvoice: boolean
) => {
  const columns = getCommonColumnDefs(t, businessRoleCode);

  return [
    ...(canCreateInvoice
      ? [
          {
            headerName: "",
            sortable: false,
            field: "selection",
            width: 30,
            minWidth: 30,
            checkboxSelection: true,
            headerCheckboxSelection: true,
            headerCheckboxSelectionFilteredOnly: false,
          },
        ]
      : []),
    ...columns.slice(0, columns.length - 1),
    {
      headerName: t("transactions.grid.cols.carrier"),
      field: "carrier",
      cellRenderer: "carrierRenderer",
      minWidth: 200,
      flex: 1,
      filter: "textFilter",
      floatingFilterComponent: "floatingTextFilter",
      floatingFilterComponentParams: {
        placeholder: t("transactions.grid.placeholder.carrier"),
        suppressFilterButton: true,
      },
    },
    ...columns.slice(-1),
    {
      headerName: "",
      sortable: false,
      field: "actions",
      filter: "textFilter",
      floatingFilterComponent: "clearFilters",
      floatingFilterComponentParams: {
        suppressFilterButton: true,
        id: "transactions-list-clear-filters-button",
      },
      width: 80,
      minWidth: 80,
    },
    {
      hide: true,
      colId: "isInvoiceable",
      filter: "textFilter",
    },
  ];
};

export const renderers = {
  ...getCommonRenderers(),
  typeRenderer: TypeRenderer,
  carrierRenderer: CarrierRenderer,
};
